<template lang="html">
  <div id="downloads-page">

    <div class="container">
      <h2 class="common-title-sm">{{ $t("shared.titles.downloads") }}</h2>

      <!-- <div class="row row-place"  v-for="(download, arInx) in downloads" :key="arInx">
        <div class="col-12 col-state">
          <h5>{{download.title}}</h5>
          <hr />
        </div>
        <div class="col-lg-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img :src="download.imageUrl">
            </div>
            <div class="col col-text">
              <p>{{download.description}}</p>
              <p class="mt-2" v-for="(doc, dInx) in download.documents" :key="dInx">

                <a target="_blank" :href="doc.documentUrl">{{doc.document_name}}</a><br>
              </p>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Sistema corrediza -->
      <div class="row row-place">
        <div class="col-12 col-state">
          <h5>Sliding system</h5>
          <hr />
        </div>
        <div class="col-lg-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/downloads/d-1.jpg">
            </div>
            <div class="col col-text">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vitae urna et ex condimentum commodo. Ut efficitur odio vitae finibus ultricies. Integer ac ultrices nisi. Ut tincidunt auctor lectus ut dapibus. Pellentesque fermentum interdum risus et facilisis. Cras interdum metus at dui aliquet, sit amet consectetur augue semper. In tincidunt sit amet dolor in feugiat. 
              </p>
              <p class="mt-2">
                <a target="_blank">Orci varius natoque </a><br />
                <a target="_blank">Morbi lobortis</a><br />
                <a target="_blank">Nam vestibulum</a><br />
                <a target="_blank">Aliquam posuere</a>
              </p>
            </div>
          </div>
        </div>
      </div>
  

      <!-- <*-- Sistemas batientes --*> -->
      <div class="row row-place">
        <div class="col-12 col-state">
          <h5>Swing systems</h5>
          <hr />
        </div>
        <div class="col-lg-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/downloads/d-2.jpg">
            </div>
            <div class="col col-text">
              <p>
                Pellentesque mattis et urna commodo elementum. Integer eget rhoncus sapien, quis tristique ipsum. Aenean eget finibus magna. Aliquam posuere, risus id aliquet dignissim, odio metus imperdiet libero, porttitor pharetra risus diam nec lectus. Pellentesque consequat nulla ac justo porttitor, ut euismod elit tempus. Morbi lobortis nisi ac dui gravida finibus. Nam vestibulum aliquam venenatis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In a ultrices justo. 
              </p>
              <p class="mt-2">
                <a target="_blank">Consectetur adipiscing</a><br />
                <a target="_blank">Dolor sit amet</a><br />
                <a target="_blank">Ipsum dolor</a>
              </p>
              <p class="mt-2">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit commodo. <a href="">click here</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <*--  --*> -->

      <!-- <*-- Ahorro energetico con ventaneria de PVC -*> -->
      <div class="row row-place">
        <div class="col-12 col-state">
          <h5>Energy saving with PVC windows</h5>
          <hr />
        </div>
        <div class="col-lg-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/downloads/d-3.jpg">
            </div>
            <div class="col col-text">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vitae urna et ex condimentum commodo. Ut efficitur odio vitae finibus ultricies. Integer ac ultrices nisi.<br>
                Ut tincidunt auctor lectus ut dapibus. Pellentesque fermentum interdum risus et facilisis. Cras interdum metus at dui aliquet, sit amet consectetur augue semper. In tincidunt sit amet dolor in feugiat. Pellentesque sagittis turpis vitae facilisis posuere. Sed elit libero, lacinia ut varius ut, vulputate et orci. Sed vel nisi malesuada, luctus eros in, cursus lorem. Nulla ac maximus sem, nec imperdiet sem. Cras et lectus sit amet erat fringilla vestibulum. Cras orci arcu, dictum et massa sit amet, ultricies volutpat lectus.
                In a ultrices justo. 
              </p>
              <p class="mt-2">
                <a target="_blank">Energy saving</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <*---  --*> -->

      <!-- <*-- Mallorquina ALUPLAST --*> -->
      <!-- <div class="row row-place">
        <div class="col-12 col-state">
          <h5>Mallorquina ALUPLAST</h5>
          <hr />
        </div>
        <div class="col-lg-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/downloads/d-4.jpg">
            </div>
            <div class="col col-text">
              <h5>ALUPLAST</h5>
              <p></p>
              <p class="mt-2">
                <a target="_blank" href="public/downloads/mallorquinaaluplast.pdf">Mallorquina ALUPLAST</a>
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <*----  --*> -->

      <!-- <*---- Persianas enrollables Europeas ALUPLAST --*> -->
      <!-- <div class="row row-place">
        <div class="col-12 col-state">
          <h5>Persianas enrollables Europeas ALUPLAST</h5>
          <hr />
        </div>
        <div class="col-lg-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/downloads/d-5.jpg">
            </div>
            <div class="col col-text">
              <p></p>
              <p class="mt-2">
                <a target="_blank" href="public/downloads/2dpersiana.pdf">2D persiana ALUPLAST</a><br />
                <a target="_blank" href="public/downloads/3dpersiana.pdf">3D persiana ALUPLAST</a>
              </p>
            </div>
          </div>
        </div>
      </div> -->

    </div>

  </div>
</template>

<script type="text/javascript">
  export default {
    data(){
      return {
        downloads:[],
      }
    },

    methods:{

      getDownloads(){
        this.$parent.inPetition=true;
        axios.get(tools.url("/downloadsFront")).then((response)=>{
            this.downloads=response.data[this.$i18n.locale];

            this.$parent.inPetition=false;
          }).catch((error)=>{
              this.$parent.handleErrors(error);
              this.$parent.inPetition=false;
          });
      },

    },

    mounted() {
      // this.getDownloads();
    }
  }
</script>
